import Repository from '@/app/shared/infrastructure/http/Repository';

export default class ProjectRepository extends Repository {
    uri = '/api/projects';
}
